import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationEaseIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAnimationEaseIn"><Path d="M3.5 20.5C13.1275 18.4103 18.4103 13.1275 20.5 3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAnimationEaseIn;
